import { useEffect } from "react";
import isEqual from "lodash/isEqual";
import { useDispatch, useSelector } from "react-redux";
import { useParams as rrUseParams } from "react-router-dom";

function areEqual(a, b) {
  return JSON.stringify(a) === JSON.stringify(b);
}

export default function useParams(arr) {
  if (!arr || arr.length === 0) return {};

  const data = useSelector((state) => {
    const ourParams = {};
    arr.forEach((key) => (ourParams[key] = state.router.params[key]));
    return ourParams;
  }, areEqual);

  return data;
}

export function ObserveRouter({ children }) {
  const rrParams = rrUseParams();
  const dispatch = useDispatch();
  const params = useSelector((state) => state.router.params);

  useEffect(() => {
    if (!isEqual(params, rrParams)) {
      dispatch({ type: "SET_ROUTER_PARAMS", params: rrParams });
    }
  }, [JSON.stringify(rrParams)]);

  return children;
}
